import { ICustomizationSettingsResponse } from "@wingspanhq/users/dist/lib/interfaces";
import { serviceCustomization } from "./serviceCustomization";

export const getCustomization =
  async (): Promise<ICustomizationSettingsResponse> => {
    const response = await serviceCustomization.get(`/customization`);
    return response.data;
  };
